import Title from './title'
import Description from './description'
import DetailBlock from './block-detail'
import AboutBlock from './block-about'

export default function Promotion({ avgTeamPayout }) {
  const t = useI18n()

  return (
    <AboutBlock>
      <Title>{ t('page:joinUs.promotion.title') }</Title>
      <Description>{ t('page:joinUs.promotion.description1') }</Description>
      <div className='h-4'/>
      <div className='flex flex-col md:space-x-8 md:flex-row'>
        <C.Image
          className='aspect-[5/3] drop-shadow-md ml-[-32px] md:ml-0 w-[100vw] md:w-full'
          type='contain'
          src={ cdn('next/join-us/promotion-4.png') }
        />

        <div className='mt-8 md:mt-0'>
          <DetailBlock
            provide={ t('page:joinUs.promotion.description3') }
            detail={ t('page:joinUs.promotion.description4') }
            statistics={ [
              t('page:joinUs.promotion.description5', { bonus: avgTeamPayout.currency() })
            ] }
          />
        </div>
      </div>
    </AboutBlock>
  )
}
